import { render } from "./LicView.vue?vue&type=template&id=6b1588f4&scoped=true"
import script from "./LicView.vue?vue&type=script&lang=js"
export * from "./LicView.vue?vue&type=script&lang=js"

import "./LicView.vue?vue&type=style&index=0&id=6b1588f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1588f4"]])

export default __exports__